module.exports = "<div class=\"captcha-wrapper\">\r\n    <div \r\n        class=\"captcha-element\"\r\n        #reCaptcha \r\n        [ngClass]=\"{'error' : hasError}\"\r\n        ></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/captcha/captcha.component.html
// module id = ./src/app/shared/components/captcha/captcha.component.html
// module chunks = main